import { faUser } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Button from '@mui/material/Button';
import ButtonGroup from '@mui/material/ButtonGroup';
import { useTheme } from '@mui/material/styles';
import { isEmpty } from 'lodash';

import PonduranceSvgIcon from '@/components/PonduranceSvgIcon/PonduranceSvgIcon';

import type { TicketNextActionProps } from './TicketNextAction.types';

const TicketNextAction = (props: TicketNextActionProps) => {
  const { hasError, onChange, value } = props;
  const theme = useTheme();

  const getLogoFillColor = () => {
    if (hasError) {
      return theme.vars.palette.error.main;
    }
    if (isEmpty(value) || value === 'customer') {
      return theme.vars.palette.primary.main;
    }
    return theme.vars.palette.common.white;
  };

  return (
    <ButtonGroup
      id="next-action-button-group"
      variant="outlined"
      {...(hasError && {
        color: hasError ? 'error' : 'primary'
      })}
    >
      {/* customer button */}
      <Button
        key="1"
        onClick={() => onChange?.('customer')}
        startIcon={<FontAwesomeIcon icon={faUser} size="1x" />}
        style={{ width: '100%' }}
        // set button color with react-hook-form value
        {...(value && {
          variant: value === 'customer' ? 'contained' : 'outlined'
        })}
        // set button color with atom value
        {...(value && {
          variant: value === 'customer' ? 'contained' : 'outlined'
        })}
      >
        Customer
      </Button>

      {/* pondurance button */}
      <Button
        key="2"
        onClick={() => onChange?.('pondurance')}
        startIcon={<PonduranceSvgIcon fillcolor={getLogoFillColor()} />}
        style={{ width: '100%' }}
        // set button color with react-hook-form value
        {...(value && {
          variant: value === 'pondurance' ? 'contained' : 'outlined'
        })}
        // set button color with atom value
        {...(value && {
          variant: value === 'pondurance' ? 'contained' : 'outlined'
        })}
      >
        Pondurance
      </Button>
    </ButtonGroup>
  );
};

export default TicketNextAction;
